module.exports = __webpack_public_path__ + "img/contents_biz@2x.4924c2b1.png";